import { APIResponse, HttpMethod } from '@cbgms/api'
import { createAsyncApiAction } from '@cbgms/base/redux/create-async-action'

export const getFeatureFlags = () => {
  return createAsyncApiAction<APIResponse<string[]>>('support', {
    method: HttpMethod.GET,
    url: `/features/enabled-features`
  })
}
